var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDummyfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#0088CC",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M946 5109 c-62 -15 -153 -68 -197 -116 -22 -24 -55 -74 -72 -111 l-32 -67 0 -2256 0 -2255 37 -76 c45 -91 103 -147 196 -191 l67 -32 1615 0 1615 0 67 32 c93 44 151 100 196 191 l37 76 0 1875 0 1876 -28 60 c-24 52 -83 115 -465 498 -385 386 -445 442 -502 470 l-65 32 -1215 2 c-708 0 -1231 -3 -1254 -8z m2336 -517 l3 -368 37 -76 c45 -91 103 -147 196 -191 l67 -32 367 -3 368 -3 0 -1776 c0 -1365 -3 -1785 -12 -1817 -16 -55 -99 -138 -154 -154 -60 -17 -3128 -17 -3188 0 -55 16 -138 99 -154 154 -18 60 -18 4408 0 4468 15 51 99 137 148 153 25 8 375 11 1177 12 l1142 1 3 -368z m686 -510 c-225 -2 -326 1 -358 10 -58 16 -141 96 -158 154 -8 29 -12 139 -12 360 l0 319 420 -420 420 -420 -312 -3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDummyfile);
export default __webpack_public_path__ + "static/media/dummyfile.3cdc80bc49c3b48b0023d8d88dc344f6.svg";
export { ForwardRef as ReactComponent };